import axios from "axios";

class SystemSettings {
  get() {
    return axios.get("/system-setting");
  }
  change(data) {
    return axios.put("/system-setting", data);
  }
  setPriceSource(data) {
    return axios.patch("/system-setting/fiat-price-source", data);
  }
  // Auto Change Settings
  getAutoChangeSettings() {
    return axios.get("/system-setting/auto-change");
  }
  updateAutoChangeSettings(data) {
    return axios.post("/system-setting/auto-change", data);
  }
  autoChangeSettingsGetData() {
    return axios.get("/system-setting/auto-change/data");
  }

  // /system-setting/auto-change/data
}

export default new SystemSettings();
